var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"m-the-header-logo",attrs:{"disabled":!_vm.isLoading,"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goToHome()}}},[_c('AtomLogoPrimary')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }